// Выбор темы. Три положения: светлая, тёмная, как в системе.
//
// «Как в системе» резолвится в конкретную тему ЗДЕСЬ, а не в CSS, и
// проставляется атрибутом data-theme на <html>. Из-за этого в styles.css
// ровно два блока палитры вместо трёх (:root, :root[data-theme=dark] и
// копия тёмной внутри @media prefers-color-scheme) — а два блока, в
// отличие от трёх, не расходятся при первой же правке.

export type ThemeChoice = 'light' | 'dark' | 'system';
export type ResolvedTheme = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'spusk.balance.theme';
export const DEFAULT_THEME: ThemeChoice = 'light';

const CHOICES: readonly ThemeChoice[] = ['light', 'dark', 'system'];

/** Всё, что не одно из трёх положений, считается «не выбрано». */
export function normalizeTheme(raw: unknown): ThemeChoice | null {
  return typeof raw === 'string' && (CHOICES as readonly string[]).includes(raw)
    ? (raw as ThemeChoice)
    : null;
}

export function resolveTheme(choice: ThemeChoice, systemPrefersDark: boolean): ResolvedTheme {
  if (choice === 'system') return systemPrefersDark ? 'dark' : 'light';
  return choice;
}

/** localStorage может бросить в приватном окне и при запрете на данные сайта. */
export function readStoredTheme(): ThemeChoice {
  try {
    return normalizeTheme(window.localStorage.getItem(THEME_STORAGE_KEY)) ?? DEFAULT_THEME;
  } catch {
    return DEFAULT_THEME;
  }
}

export function storeTheme(choice: ThemeChoice): void {
  try {
    window.localStorage.setItem(THEME_STORAGE_KEY, choice);
  } catch {
    /* Тема — удобство, а не состояние работы: не сохранилась, и ладно. */
  }
}

export function systemPrefersDark(): boolean {
  return typeof window.matchMedia === 'function'
    ? window.matchMedia('(prefers-color-scheme: dark)').matches
    : true;
}

/** Единственное место, где тема попадает в DOM. */
export function applyTheme(choice: ThemeChoice): ResolvedTheme {
  const resolved = resolveTheme(choice, systemPrefersDark());
  document.documentElement.setAttribute('data-theme', resolved);
  return resolved;
}
